(ns com.theplantscape.local-store.polyculture-db
  (:require [com.theplantscape.local-store.core-db :refer [diag map->datascript-vec rm-entity]]
            [com.theplantscape.local-store.utils :refer [namespace-map]]
            [datascript.core :as d]))

(defn remove-polycultures []
  (rm-entity
   (flatten
    (vec (d/q {:find ['?e]
               :where [['?e :polyculture.plant/plant-entity-id '?plant]]} @diag)))))

(defn update-polyculture-settings [data]
  (let [result (first (first (d/q {:find ['(pull ?e [*])]
                                   :where [['?e :polyculture/title]]}
                                  @diag)))
        id (:db/id result)]
    (if id
      (d/transact diag (map->datascript-vec id data))
      (d/transact diag (map->datascript-vec data))))
  ;(d/entity diag key value)
  )

(defn insert-polyculture-data
  [poly]
  (d/transact!
   diag
   (if (vector? poly)
     (mapv map->datascript-vec poly)
     ;;(reduce (fn [v item] (into v (map->datascript-vec item)))  [] poly)
     (map->datascript-vec poly))))

(def query-polycultures
  {:find ['?e '?name]
   :keys '[id name]
   :where [['?e :polyculture/name '?name]
           ;['?e :plant/scientific-name '?sci-name]
           ;['(get-else $ ?e :plant.season/fruiting :nil) '?season]
           #_['?e :plant/type '?type]]})

(def get-polyculture-entity-id-from-uuid
  {:find ['?e]
   :in '[$ ?polyculture]
   :where [['?e :xt/id '?polyculture]]})

(def query-polyculture
  {:find ['(pull ?e [*])]
   :in '[$ ?polyculture]
   :where [['?e :polyculture.plant/polyculture '?polyculture]]})

(def query-polyculture-plants
  {:find ['?e '?position '?plant-entity-id '?plant-type '?plant-uuid '?name]
   :keys '[entity-id points plant-entity-id type plant-uuid label]
   :in '[$ ?polyculture]
   :where [['?e :polyculture.plant/polyculture '?polyculture]
           ['?e :polyculture.plant/plant-entity-id '?plant-entity-id]
           ['?plant-entity-id :plant/type '?plant-type]
           ['?plant-entity-id :plant/id '?plant-uuid]
           ['?e :polyculture.plant/name '?name]
           ['?e :polyculture.plant/points '?position]]})

(def query-polyculture-plants-stats
  {:find ['?name '?plant '(count ?e)]
   :keys '[name plant-entity-id count]
   :in '[$ ?polyculture]
   :where [['?e :polyculture.plant/polyculture '?polyculture]
           ['?e :polyculture.plant/plant-entity-id '?plant]
           ['?e :polyculture.plant/name '?name]
           ;['?plant :plant/common-name '?name]
           #_['?e :polyculture.plant/position '?position]]})

(defn fetch-polyculture-entity-id-from-uuid [uuid]
  (-> (d/q get-polyculture-entity-id-from-uuid @diag uuid)
      first
      first))

(defn fetch-polyculture [id]
  (d/q query-polyculture @diag id))

(defn fetch-polycultures []
  (d/q query-polycultures @diag))

(defn fetch-polyculture-plants [polyculture]
  (d/q query-polyculture-plants @diag polyculture))

(defn fetch-polyculture-plants-stats [polyculture]
  (d/q query-polyculture-plants-stats @diag polyculture))

(comment
  (d/q {:find ['(pull ?e [*])]
        :where [['?e :polyculture/name]]}
       @diag)

  (d/q {:find ['?a]
        :where [['_ '?a]]}
       @diag)

  (d/entity @diag [:polyculture/name])
  @diag
  (d/q query-polycultures @diag)
  (fetch-polycultures)
  (fetch-polyculture "")
  (fetch-polyculture-plants 37)

  (fetch-polyculture-plants 37)
  (fetch-polyculture-plants-stats 37)
  (insert-polyculture-data
   {:polyculture/name "poly 1"
    :polyculture/description "poly 1"
    :polyculture/plants []})

  (insert-polyculture-data
   {:polyculture.plant/position [50 50]
    :polyculture.plant/polyculture 37})

  (insert-polyculture-data
   {:polyculture.plant/position [150 150]
    :polyculture.plant/plant 1
    :polyculture.plant/polyculture 37})

  (insert-polyculture-data
   [{:polyculture/name "poly 1"
     :polyculture/description "poly 1"
     :polyculture/plants []}
    {:polyculture/name "poly 2"
     :polyculture/description "poly 2"
     :polyculture/plants []}]))
